import { AppState } from 'modules/rootReducer';
import { MessageActivityLogItem } from 'API/messages';

export const messagesSelecor = () => (state: AppState): MessageActivityLogItem[] => {
  return state.activityLog.messages;
};
